import script from "./AnimationsMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnimationsMain.vue?vue&type=script&setup=true&lang=ts"

import "./AnimationsMain.vue?vue&type=style&index=0&id=19607610&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19607610"]])

export default __exports__